export const main = ( ( $ ) => {
	$( window ).on( 'load', () => {
		const utm_campaign = prepareUtmCookie( 'utm_campaign' );
		const utm_content = prepareUtmCookie( 'utm_content' );
		const utm_medium = prepareUtmCookie( 'utm_medium' );
		const utm_source = prepareUtmCookie( 'utm_source' );
		const utm_term = prepareUtmCookie( 'utm_term' );

		let i = setInterval( () => {
			if ( $( '.mktoEmailField' ).length ) {
				clearInterval( i );

				$( 'input[name="ccltutmcampaign"]' ).val( utm_campaign );
				$( 'input[name="ccltutmcontent"]' ).val( utm_content );
				$( 'input[name="ccltutmmedium"]' ).val( utm_medium );
				$( 'input[name="ccltutmsource"]' ).val( utm_source );
				$( 'input[name="ccltutmterm"]' ).val( utm_term );
			}
		}, 100 );
	});

	function setCookie( cname, cvalue, exdays ) {
		const d = new Date();
		d.setTime( d.getTime() + exdays * 24 * 60 * 60 * 1000 );
		const expires = 'expires=' + d.toUTCString();
		document.cookie = cname + '=' + cvalue + '; ' + expires + ';path=/';
	}

	function getCookie( cname ) {
		const name = cname + '=';
		const decodedCookie = decodeURIComponent( document.cookie );
		const ca = decodedCookie.split( ';' );

		for ( let i = 0; i < ca.length; i++ ) {
			let c = ca[i];

			while ( c.charAt( 0 ) == ' ' ) {
				c = c.substring( 1 );
			}

			if ( c.indexOf( name ) == 0 ) {
				return c.substring( name.length, c.length );
			}
		}

		return '';
	}

	function getUrlParameter( name ) {
		name = name.replace( /[\[]/, '\\[').replace(/[\]]/, '\\]' );
		const regex = new RegExp( '[\\?&]' + name + '=([^&#]*)' );
		const results = regex.exec( location.search );

		return results === null
			? ''
			: decodeURIComponent( results[1].replace( /\+/g, ' ' ) );
	}

	function prepareUtmCookie( cookie_name ) {
		let cookie_value = getUrlParameter( cookie_name );

		if ( cookie_value ) {
			setCookie( cookie_name, cookie_value, 1 );
		} else {
			cookie_value = getCookie( cookie_name );
		}

		return cookie_value;
	}
} )( window.jQuery );

// export const munchkin = (() => {
// 	let didInit = false;
// 	function initMunchkin() {
// 		if (didInit === false) {
// 			didInit = true;
// 			window.Munchkin.init('373-NCW-798');
// 		}
// 	}
// 	const s = document.createElement('script');
// 	s.type = 'text/javascript';
// 	s.async = true;
// 	s.src = '//munchkin.marketo.net/munchkin.js';
// 	s.onreadystatechange = function () {
// 		if (this.readyState == 'complete' || this.readyState == 'loaded') {
// 			initMunchkin();
// 		}
// 	};
// 	s.onload = initMunchkin;
// 	document.getElementsByTagName('head')[0].appendChild(s);
// })();

export const gclid = () => {
	function getParam( p ) {
		const match = RegExp( '[?&]' + p + '=([^&]*)' ).exec( window.location.search );

		return match && decodeURIComponent( match[1].replace( /\+/g, ' ' ) );
	}

	function getExpiringRecord( value ) {
		const expiryPeriod = 90 * 24 * 60 * 60 * 1000,
			expiryDate = new Date().getTime() + expiryPeriod;

		return {
			value: value,
			expiryDate: expiryDate,
		};
	}

	function manageGclid() {
		// (SOAP) name of your form field
		const gclidFormFieldName = 'MostRecentGclid';

		/* -- NO NEED TO TOUCH BELOW THIS LINE! -- */

		const gclidParamName = 'gclid',
			gclidPersistentName = 'most_recent_gclid';

		const gclsrcParamName = 'gclsrc',
			gclsrcOptions = {
				'Search Ads 360': 'aw.ds',
				'Search Ads 360 No Parallel': 'ds',
				'Non-Google Parallel': '3p.ds',
			};

		const enablePersistence = true;

		let currentGclidParam = getParam( gclidParamName ),
			currentGclsrcParam = getParam( gclsrcParamName ),
			currentTimeMillis = new Date().getTime();

		let storedGclidRecord;
		if (enablePersistence) {
			storedGclidRecord = JSON.parse(
				localStorage.getItem( gclidPersistentName )
			);
		}

		let newGclidRecord;
		if (
			currentGclidParam &&
			( ! currentGclsrcParam ||
				currentGclsrcParam == gclsrcOptions['Search Ads 360'] )
		) {
			newGclidRecord = getExpiringRecord( currentGclidParam );
			if ( enablePersistence ) {
				localStorage.setItem(
					gclidPersistentName,
					JSON.stringify( newGclidRecord )
				);
			}
		}

		let activeGclidRecord = newGclidRecord || storedGclidRecord || {};

		let isGclidValid =
			activeGclidRecord.value &&
			currentTimeMillis < activeGclidRecord.expiryDate;

		if ( isGclidValid ) {
			window.MktoForms2.whenReady( ( mktoForm ) => {
				let gclidFormFieldNames = [].concat( gclidFormFieldName );

				let mktoFields = gclidFormFieldNames.reduce(
					( acc, nextField ) => {
						acc[nextField] = activeGclidRecord.value;
						return acc;
					},
					{}
				);

				mktoForm.addHiddenFields( mktoFields );
			} );
		}
	}

	manageGclid();
};

export const utm = () => {
	main;
	// munchkin;
	gclid;
};
